import { render } from "./SiteConfig.vue?vue&type=template&id=79c7af3d"
import script from "./SiteConfig.vue?vue&type=script&lang=js"
export * from "./SiteConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__